import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { REMOVE_AUTHENTICATION_TOKEN } from "src/app/reducers/AuthenticationReducer";
import { useAuthenticationTokenCookie } from "src/authentication/hooks/useAuthenticationTokenCookie";

export const useRemoveAuthenticationToken = () => {
  const { remove: removeAuthenticationTokenCookie } =
    useAuthenticationTokenCookie();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useCallback(async () => {
    removeAuthenticationTokenCookie();
    await queryClient.invalidateQueries("authenticationToken");
    dispatch({
      type: REMOVE_AUTHENTICATION_TOKEN,
    });
  }, [dispatch, queryClient, removeAuthenticationTokenCookie]);
};
